import { cn } from '@/lib/cn';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const DialogFooter = ({ children, className }: Props) => {
  return (
    <div
      className={cn(
        'flex items-center justify-between px-7 pb-7 pt-6',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default DialogFooter;
